module.exports = __webpack_public_path__ + "img/search.1257df7d.svg";